//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var columns1 = [{
  title: '参数名称',
  dataIndex: 'name',
  align: 'center',
  scopedSlots: {
    customRender: 'name'
  }
}, {
  title: '参数值',
  dataIndex: 'remark',
  align: 'center',
  scopedSlots: {
    customRender: 'remark'
  }
}];
var tableData1 = [];
export default {
  name: 'LoadPrinting',
  components: {},
  data: function data() {
    return {
      title: '打印预览',
      visible: false,
      model: {},
      columns1: columns1,
      tableData1: tableData1,
      url: {
        qrCodeServer: window._CONFIG['domianURL'] + '/sys/common/qrCode'
      }
    };
  },
  created: function created() {},
  methods: {
    detail: function detail(record) {
      this.visible = true;
      this.model = record;
      this.tableData1 = record.paramList;
    },
    getQrCodeView: function getQrCodeView() {
      return this.url.qrCodeServer + '/' + this.model.assetCode;
    },
    handleCancel: function handleCancel() {
      this.visible = false;
    },
    do_qr_print: function do_qr_print() {
      window.print();
    }
  }
};